import { render, staticRenderFns } from "./UserAdminPage.vue?vue&type=template&id=8299ce66&"
import script from "./UserAdminPage.vue?vue&type=script&lang=js&"
export * from "./UserAdminPage.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminPage.vue?vue&type=style&index=0&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports